import React, { useState } from "react";


import { Grid } from "@material-ui/core/";
import ModalThree from "../../components/Modals/ModalThree";
import Buttons from "../../components/Button/Button";
import fbIcon from "../../assets/imgs/socialIcon/Facebook-Icon.svg";
import google from "../../assets/imgs/socialIcon/google.png";
import styles from "./form.module.css";
import Image from "next/image";

import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import CallTwoToneIcon from "@mui/icons-material/CallTwoTone";

function Welcome(props) {
  const {
    open,
    handleClose,
    onClickFacebook,
    onClickGoogle,
    onClickEmail,
    onClickPhone,
    handleCloseModal,
    ModalTitle,
  } = props;

  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);
  // console.log(ModalTitle, "ModalTitle");
  return (
    <>
      {/* === Sign In Modal Start */}
      <ModalThree
        open={open}
        handleClose={handleClose}
        width="540px"
        titileColor="#33B651"
        body={
          <div className={styles.SignContainer}>
            <div className={styles.SignContainerInner}>
              <h3>{ModalTitle}</h3>
              {/* <p>Sign in or sign up to continue</p> */}

              <div className={styles.SignFormBody}>
                <Grid container spacing={3}>
                  {/* <Grid item xs={12} md={12}>
                  <div className="SocialButton">
                    <Buttons
                      icon={<Image src={fbIcon} className={styles.IconAlign}/>}
                      label="Continue with Facebook"
                      buttonColor="#1877F2"
                      border="#1877F2 1px solid"
                      color="#fff"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={onClickFacebook}
                    />
                  </div>
                </Grid>  */}

                  {/* <Grid item xs={12} md={12}>
                  <div className="SocialButton">
                    <Buttons
                      icon={<Image src={google} className={styles.IconAlign} />}
                      label="Continue with Google"
                      buttonColor="#fff"
                      border="#A4A7B0 1px solid"
                      color="#0B132B"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={() => signIn("google")}
                    />
                  </div>
                </Grid>  */}

                  {/* <Grid item xs={12} md={12}>
                  <div className={styles.OrDevider} ><span>or</span></div>
                </Grid> */}

                  <Grid item xs={12} md={12}>
                    <div
                      className="SocialButton"
                      onClick={() => handleCloseModal()}
                    >
                      <Buttons
                        label={props.WithEmail}
                        buttonColor="#fff"
                        border="#E4E8EC 1px solid"
                        color="#004FE0"
                        width="100%"
                        height="48px"
                        fontSize="14px"
                        onClick={onClickEmail}
                        icon={<MailOutlineRoundedIcon />}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div
                      className="SocialButton"
                      onClick={() => handleCloseModal()}
                    >
                      <Buttons
                        label={props.WithPhone}
                        buttonColor="#fff"
                        border="#E4E8EC 1px solid"
                        color="#004FE0"
                        width="100%"
                        height="48px"
                        fontSize="14px"
                        onClick={onClickPhone}
                        icon={<CallTwoToneIcon />}
                        IconAlign="left"
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className={styles.AlreadyText}>
                      {props.AlreadySignLabel !== "Sign in"
                        ? "Don't have an account?"
                        : "Already have an account?"}
                      <a onClick={() => props.handleClose()}>
                        <span onClick={() => props.SignHandleOpen()}>
                          {props.AlreadySignLabel}
                        </span>
                      </a>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        }
      />
      {/* === Sign In Modal End */}
    </>
  );
}

export default Welcome;
